export default "__VITE_ASSET__ChOQlPYC__"